<template>
  <div class="home" :class="{'horizontal': isHorizontal}">
    <!-- 底部背景 -->
    <div class="h5-loading-cover quwanwan-cover" v-if="isInit" style="display: block;">
      <!-- <img v-if="isInit" :src="require(`@/assets/img/${theme[2].imgUrl}/loading_cover.jpg`)"> -->
      <img v-if="init.identity === 2316" class="cover-img" :src="require(`@/assets/img/loading_cover_word.png`)">
      <img v-else :src="require(`@/assets/img/blue/loading_cover.jpg`)">
    </div>

    <!-- 悬浮框 -->
    <div class="am-btn" v-show="token && $route.query.g_token && isInit" @click="open = !open" ref="am">
      <img v-if="isIOS() && status.event_info.status" :src="status.event_info.icon" alt="">
      <img v-else :src="require(`@/assets/img/${theme[2].imgUrl}/icon-fg_t.png`)">
      <em class="qiwanwansdk_fuli" style="display: inline;">礼包</em>
    </div>

    <!-- 红包版弹窗信息框 -->
    <mu-dialog class="mudia" v-if="isIOS() && status.event_info.status" :padding="20" width="360" scrollable :open.sync="open" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_user">
          <div class="avatar">
            <img :src="require(`@/assets/img/default_img.png`)">
          </div>
          <span class="md_username">{{status.username}}</span>
        </div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="open = !open"></mu-icon>
      </div>
      <div class="md_content">
        <hd-draw-index :realName="isRealName || goRealNameRoute" :bindPhoneStatus="isBindPhone" @closeHeartbeatWindow="closeHeartbeatWindow" @setGameUrl="setGameUrl" />
      </div>
    </mu-dialog>

    <mu-drawer v-if="!(isIOS() && status.event_info.status)" :open.sync="open" :docked="docked" :right="position === 'right'" width="85%">
      <draw-index :realName="isRealName || goRealNameRoute" :bindPhoneStatus="isBindPhone" />
    </mu-drawer>

    <!-- 游戏容器 -->
    <iframe class="h5-game-iframe" scrolling="no" allowtransparency="yes" name="game-frame"
        :src="gameUrl" frameborder="no" :style="`width: ${iframeWidth}px; height: ${iframeHeight}px;`">
    </iframe>

    <!-- 新登陆注册弹窗 -->
    <mu-dialog class="new-login" :open.sync="openSimple" max-width="340px" width="90%" :overlay-close="false" v-show="!token">
      <div>
        <div class="l-title" :style="`color: ${themeConfig.dark}`">
          <p v-if="loginType === 'user'">账号登录</p>
          <p v-if="loginType === 'register'">账号注册</p>
          <p v-if="loginType === 'phone'">手机登录</p>
          <p v-if="loginType === 'reset'">忘记密码</p>
          <div class="back" v-if="loginType === 'reset'" @click="switchLoginType('user')">
            <img :src="require('@/assets/img/backIcon.png')">
          </div>
        </div>
        <div v-if="loginType === 'user' || loginType === 'register'">
          <div class="l-input" :class="loginBoxClick ? 'selcet-input' : ''">
            <div class="i-title">账  号:</div>
            <input type="text" class="input-box" @focus="loginBoxClick = false" v-model="loginPhoneForm.username" placeholder="请输入账号">
            <span class="select-icon" @click="loginBoxClick = !loginBoxClick" v-if="loginType === 'user'">
              <img :src="require('@/assets/img/selectIcon.png')">
            </span>
            <div class="select-list" v-if="loginType === 'user'">
              <div class="item" v-for="(item, index) in userInputList" :key="index">
                <span class="p" @click="selectUser(item)">{{item}}</span>
                <span class="clean" @click="cleanUser(item, index)">
                  <img :src="require('@/assets/img/cleanUser.png')">
                </span>
              </div>
            </div>
          </div>
          <div class="l-input">
            <div class="i-title">密  码:</div>
            <input :type="visibility ? 'text' : 'password'" class="input-box" v-model="loginPhoneForm.password" placeholder="请输入密码">
            <span class="select-icon" v-if="loginType === 'user'" @click="visibility = !visibility">
              <mu-icon class="icon-box" v-if="visibility" value="visibility"></mu-icon>
              <mu-icon class="icon-box" v-else value="visibility_off"></mu-icon>
            </span>
          </div>
        </div>
        <div v-if="loginType === 'phone'">
          <div class="l-input">
            <div class="i-title">手机号:</div>
            <input type="text" maxlength="11" class="input-box" v-model="phoneForm.phone" placeholder="请输入手机号">
          </div>
          <div class="l-input">
            <div class="i-title">验证码:</div>
            <input type="text" class="input-box input-code" v-model="phoneForm.code" placeholder="请输入验证码">
            <span class="get-code" @click="getCode">{{codeDisabled ? `${codeTime}s`: '获取验证码'}}</span>
          </div>
        </div>
        <div v-if="loginType === 'reset'">
          <div class="l-input">
            <div class="i-title">账  号:</div>
            <input type="text" class="input-box" v-model="resetForm.username" placeholder="请输入账号">
          </div>
          <div class="l-input">
            <div class="i-title">手机号:</div>
            <input type="text" maxlength="11" class="input-box" v-model="resetForm.phone" placeholder="请输入手机号">
          </div>
          <div class="l-input">
            <div class="i-title">验证码:</div>
            <input type="text" class="input-box input-code" v-model="resetForm.code" placeholder="请输入验证码">
            <span class="get-code" @click="getCode('reset')">{{resetDisabled ? `${resetCodeTime}s`: '获取验证码'}}</span>
          </div>
          <div class="l-input">
            <div class="i-title">密  码:</div>
            <input type="password" class="input-box" v-model="resetForm.password" placeholder="请输入密码">
          </div>
          <div class="l-input">
            <div class="i-title">密  码:</div>
            <input type="password" class="input-box" v-model="resetForm.password_confirmation" placeholder="请再次输入密码">
          </div>
        </div>
        <div class="l-tips" v-if="loginType !== 'reset'">
          <div :class="loginType === 'user' ? 'tips-left' : ''">
            <span class="l-img" v-if="!check" @click="check = true"><img :src="require('@/assets/img/checkNo.png')"></span>
            <span class="l-img" v-if="check" @click="check = false"><img :src="require('@/assets/img/checkYes.png')"></span>
            <span class="p">我已阅读并同意<a @click="userContentCheck">{{loginType === 'user' ? '用户协议' : '用户协议及私隐协议'}}</a></span>
          </div>
          <span class="lose-pwd" v-if="loginType === 'user'" @click="switchLoginType('reset')">忘记密码</span>
        </div>
        <div class="l-button" :style="`background: ${themeConfig.dark}`">
          <div class="b-button" v-if="loginType === 'register'" v-loading="registerLoading" @click="getRegister">注 册</div>
          <div class="b-button" v-if="loginType === 'user'" v-loading="adminLoading" @click="login('ACCOUNT')">登 录</div>
          <div class="b-button" v-if="loginType === 'phone'" v-loading="adminLoading" @click="login('PHONE')">登 录</div>
          <div class="b-button" v-if="loginType === 'reset'" v-loading="resetLoading" @click="resetSubmit">确 认</div>
        </div>
        <div class="l-bot" v-if="loginType === 'register'">
          <span class="left" @click="switchLoginType('user')">账号登录</span>
          <span class="right" @click="switchLoginType('phone')">手机登录</span>
        </div>
        <div class="l-bot" v-if="loginType === 'user'">
          <span class="left" @click="switchLoginType('phone')">手机登录</span>
          <span class="right" @click="switchLoginType('register')">账号注册</span>
        </div>
        <div class="l-bot" v-if="loginType === 'phone'">
          <span class="left" @click="switchLoginType('user')">账号登录</span>
          <span class="right" @click="switchLoginType('register')">账号注册</span>
        </div>
      </div>
    </mu-dialog>

    <!-- 实名认证弹窗 -->
    <mu-dialog :open.sync="isRealName" max-width="300px" :overlay-close="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p>尊敬的用户，您好：</p>
        <p>根据文化部《互联网文化管理暂行规定》和《网络游戏管理暂行办法》相关规定，未完成实名认证的用户将不能在在游戏中进行充值，请您完成实名认证后在进行相关的充值操作。</p>
      </div>
      <div class="dl-footer">
        <mu-button :color="themeConfig.dark" full-width text-color="#fff" @click="isRealName = false">立即认证</mu-button>
      </div>
    </mu-dialog>

    <!-- 绑定手机弹窗 -->
    <mu-dialog :open.sync="isBindPhoneOpen" max-width="300px" :overlay-close="false">
      <p class="dl-title" slot="title">温馨提示</p>
      <div class="dl-content mb20">
        <p class="dl-c-title">请绑定手机号码，体验完整游戏</p>
        <p>*根据国家网络信息办公室颁布的《移动互联网应用程序信息服务管理规定》，从2016年8月1日起，互联网注册用户应当进行基于移动电话号码等真实身份信息认证。</p>
      </div>
      <div class="dl-footer">
        <mu-button :color="themeConfig.dark" full-width text-color="#fff" @click="isBindPhoneOpen = false">立即绑定</mu-button>
      </div>
    </mu-dialog>

    <!-- (iframe) -->
    <iframe class="window_iframe" :src="payUrl"></iframe>

    <!-- 新支付弹窗 -->
    <mu-dialog :padding="0" width="300px" :open.sync="payDialog">
      <div class="dialog-box" v-loading="payLoading">
          <!-- 移动支付 -->
          <div class="title-box">
            <p class="dl-title">充值中心</p>
            <mu-icon value="close" class="close" @click="closePay"></mu-icon>
          </div>
          <div class="mobile" v-if="!code_img_url">
            <div class="dl-cont">
              <p class="dl-c-title">【{{payData.server_name}}】<span>{{payData.role_name}}</span></p>
              <p class="money">¥ {{payData.money}}</p>
              <p class="money-name">{{payData.product_name}}</p>
            </div>
            <div class="dl-bot">
              <div class="dl-b-title">
                <div class="line"></div>
                <span>请选择支付方式</span>
              </div>
              <div class="btn-box">
                <mu-button class="btn" :color="themeConfig.dark" text-color="#fff" @click="pay('wx')">微信</mu-button>
                <mu-button class="btn" :color="themeConfig.dark" text-color="#fff" v-if="!isWeixin" @click="pay('ali')">支付宝</mu-button>
              </div>
            </div>
          </div>

          <!-- 扫码支付 -->
          <div class="pc" v-if="code_img_url && isPC">
            <div class="pc-img-box">
              <img :src="code_img_url" alt="">
            </div>
            <p class="pc-title">使用<span :style="`color: ${payName === '微信' ? '#2EBE37': '#33ABFF'}`">{{payName}}</span>扫码，支付<span class="pc-money">{{payData.money}}</span>元</p>
            <!-- <a class="pc-a" :href="pay_url">点此直接支付</a> -->
          </div>
      </div>
    </mu-dialog>

    <!-- 心跳检测 -->
    <heartbeat ref="heartbeat" :hasHeartbeat.sync="hasHeartbeat" :rechargeObj.sync="rechargeObj" @heartbeatFunc="heartbeatFunc" />

    <!-- 用户协议及隐私协议弹窗 -->
    <mu-dialog transition="slide-bottom" scrollable fullscreen :padding="0" :append-body="false" :open.sync="openFullscreen">
       <mu-appbar :color="themeConfig.dark" title="用户协议及隐私协议" class="app-bar">
          <mu-button slot="left" icon @click="openFullscreen = false">
            <mu-icon value="close"></mu-icon>
          </mu-button>
       </mu-appbar>
       <div class="user-content">
         <iframe :src="userContent" frameborder="0" :style="`width: ${iframeWidth}px; height: ${iframeHeight - 56}px;`"></iframe>
       </div>
    </mu-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DrawIndex from '@/views/components/DrawIndex'
import HdDrawIndex from '@/views/components/hdui/DrawIndex'
import { validate, isMobile, isWeixin, browser, isIOS } from '@/utils/validate'
import { getToken, setToken, moveDiv, removeToken, newPromise, wx, h5IosWapSdk } from '@/utils'
import { sendSms, sendReSms } from '@/api/sendSms'
import { phoneLogin, oneLogin } from '@/api/login'
import { getRegisterAccount, resetPassword } from '@/api/register'
import { pay, getAgreementUrl, wxJsPayNew, paySwitch } from '@/api/pay'
import Heartbeat from '@/views/components/heartbeat'
import Cookies from 'js-cookie'
const urlPath = process.env.NODE_ENV === 'production' ? '/play/' : '/'
export default {
  name: 'home',
  data () {
    return {
      adminLoading: false, //  账号密码登陆按钮loading
      registerLoading: false, //  注册按钮的loading
      qsLoading: false, //  一键注册请求loading
      resetLoading: false, // 重置密码的loading
      visibility: false, //  密码的显示隐藏
      docked: false,
      open: false,
      openFullscreen: false, //  全屏协议弹窗
      payDialog: false, //  支付窗口
      payLoading: false, //  支付点击loading
      position: 'left',
      isLogin: false,
      isPC: !isMobile(), //  是否为PC
      isWeixin: isWeixin(),
      openSimple: false,
      check: true,
      isRealName: false, //  控制弹窗实名认证的窗口
      goRealNameRoute: false, //  跳转弹窗实名认证
      payUrl: '', //  iframe的url地址
      loginPhoneForm: { //  切换账号
        username: '',
        password: ''
      },
      phoneForm: {
        phone: '',
        code: ''
      },
      resetForm: { //  重设密码form
        username: '',
        phone: '',
        code: '',
        password: '',
        password_confirmation: ''
      },
      loginType: 'user', // user账号 phone手机 register注册 reset重设密码
      codeTime: 0, // 倒计时
      resetCodeTime: 0, //  重置倒计时
      codeDisabled: false,
      resetDisabled: false,
      iframeWidth: 0,
      iframeHeight: 0,
      gameUrl: '', //  游戏加载url
      userContent: '', // 获取url
      payData: { //  支付的信息
        server_name: '', //  服务器名称
        role_name: '', //  角色名称
        money: 0, //  充值金额
        product_name: '' // 金币名称
      },
      code_img_url: '', //  支付url图片地址
      pay_url: '', //  支付url地址
      payName: '',
      order_id: '', //  订单id
      orderCount: 0, //  循环次数
      userList: [], //  获取的账号列表
      userInputList: [], // input框的账号列表
      loginBoxClick: false,
      isBindPhone: false, //  控制打开侧边栏后显示绑定页面
      sid: '', //  loadGame的一个参数
      isBindPhoneOpen: false,
      hasHeartbeat: false, //  心跳检测
      rechargeObj: {}, //  充值防沉迷obj
      isOneLogin: 0 // 一键登录
    }
  },
  components: {
    DrawIndex,
    Heartbeat,
    HdDrawIndex
  },
  computed: {
    ...mapGetters([
      'isHorizontal',
      'theme',
      'init',
      'token',
      'themeConfig',
      'isInit',
      'status',
      'idfa'
    ])
  },
  mounted () {
    if (this.$route.query.seqId && this.$route.query.connectSys) {
      window.close()
    }
    this.fullIframe()
    this.isOneLogin = this.$route.query.isOneLogin || 0
    if (this.isOneLogin === '1') {
      window['weOneClick'] = (data) => {
        this.oneLogin(data)
      }
    }
    if (this.$route.query.g_token) {
      // 解决+号变空格的情况
      this.$route.query.g_token = this.$route.query.g_token.replace(/\s+/g, '+')
      this.$store.commit('SET_APPID', this.$route.query.g_token)
      this.getImei()
      this.getInit()
    } else {
      this.$toast.error({ message: '参数缺失', time: 0 })
      return
    }
    moveDiv(this.$refs.am)
    this.payFunc()
    this.checkIosTraceless()
  },
  watch: {
    codeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.codeTime > 0 && this.codeTime--
        }, 1000)
      } else {
        this.codeDisabled = false
      }
    },
    resetCodeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.resetCodeTime > 0 && this.resetCodeTime--
        }, 1000)
      } else {
        this.resetDisabled = false
      }
    }
  },
  methods: {
    // 初始显示流程
    initShow () {
      if (this.userList.length > 0) {
        if (sessionStorage.getItem('username') && sessionStorage.getItem('username') !== 'undefined') {
          const username = sessionStorage.getItem('username')
          sessionStorage.removeItem('username')
          this.selectUser(username)
          return
        }
        this.selectUser(this.userList[0].username)
        return
      }
      if (this.$route.query.isOneLogin === '1') {
        return
      }
      this.loginType = 'register'
      this.quickRegister()
    },
    // 获取设备信息
    getImei () {
      let idfa
      if (navigator.hasOwnProperty('xdevice_info')) {
        idfa = navigator.xdevice_info.idfa || this.$route.query.idfa || this.$route.query.imei || 'h5_imei'
      } else {
        idfa = (typeof this.$route.query.idfa === 'object' ? this.$route.query.idfa[0] : this.$route.query.idfa) || (typeof this.$route.query.imei === 'object' ? this.$route.query.imei[0] : this.$route.query.imei) || 'h5_imei'
      }
      this.$store.commit('SET_IDFA', idfa)
    },
    // 公众号登陆流程
    wxLogin () {
      if (!this.$route.query.token) {
        const reqStr = 'game_id=' + this.init.identity + '&agent_id=' + this.$route.query.agent_id || 100000 + '&site_id=' + this.$route.query.site_id || 0 + '&cplaceid=' + this.$route.query.cplaceid + '&idfa=' + this.idfa
        window.location.href = `//webapi.693975.com/web/index.php` + '?r=login/wx-auth&' + reqStr + '&callback=' + `${encodeURIComponent(window.location.origin + urlPath + '?g_token=' + this.$route.query.g_token + '&' + reqStr)}`
      } else {
        setToken(this.$route.query.token)
        const reqStr = 'game_id=' + this.init.identity + '&agent_id=' + this.$route.query.agent_id || 100000 + '&site_id=' + this.$route.query.site_id || 0 + '&cplaceid=' + this.$route.query.cplaceid + '&idfa=' + this.idfa
        window.location.replace(window.location.origin + urlPath + '?g_token=' + this.$route.query.g_token + '&' + reqStr)
      }
    },
    // 调整iframe框全屏大小
    fullIframe () {
      var num = 0
      this.iframeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.iframeWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      this.$store.commit('SET_ISHORIZONTAL', (window.orientation === 90 || window.orientation === -90)) //  判断是否横屏
      if (!(window.orientation === 90 || window.orientation === -90)) {
        this.iframeHeight -= num
      }
      this.$nextTick(() => {
        window.addEventListener('orientationchange', () => {
          setTimeout(() => {
            this.iframeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            this.iframeWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            this.$store.commit('SET_ISHORIZONTAL', (window.orientation === 90 || window.orientation === -90)) //  判断是否横屏
            if (!(window.orientation === 90 || window.orientation === -90)) {
              this.iframeHeight -= num
            }
            moveDiv(this.$refs.am)
          }, 350)
        })
      })
    },
    //  跳转到实名认证
    goRealName () {
      this.isRealName = true
      this.open = true
    },
    goBindPhone () {
      this.isBindPhone = true
      this.open = true
    },
    // 处理内嵌iframe的方法
    payFunc () {
      /** 处理内嵌iframe传来的参数 */
      window.addEventListener('message', (e) => {
        if (e.data.dataType === 3 || e.data.dataType === '3') {
          e.data.dataType = Number(e.data.dataType)
          // 进入游戏 存储角色信息
          this.$store.commit('SET_GAMEDATA', e.data)
        }
        // 游戏sdk调起支付框
        if (e.data.type === 'cp_pay') {
          this.payData = e.data
          if (isIOS() && !this.isWeixin && Number(this.$route.query.appleinfo)) {
            paySwitch({
              op: 'cz',
              time: Math.round(new Date().getTime() / 1000),
              os: 'ios',
              gmi: this.payData.game_id,
              agi: this.$route.query.agent_id || 100000,
              sti: this.$route.query.site_id || 0,
              oiM: this.payData.money,
              uri: this.payData.uid,
              urN: this.status.username,
              rli: this.payData.role_id,
              rlN: this.payData.role_name,
              srvri: this.payData.server_id,
              srviN: this.payData.server_name,
              ext: this.payData.ext,
              prdti: this.payData.product_id,
              prdtN: this.payData.product_name,
              prdtD: this.payData.product_desc,
              pgPrdti: this.payData.product_id
            }).then(res => {
              if (res.data.zt === 0) {
                this.pay('apple')
              } else {
                this.payDialog = true
              }
            }).catch(() => {
              this.$toast.error('系统繁忙,请重试~')
            })
          } else {
            this.payDialog = true
          }
        }
        // 游戏ID转换处理
        if (e.data.type === 'rebuild_user_info') {
          e.data.appid = this.init.identity
          e.data.type = 'reportUserInfo_web_do'
          window.frames[0].window.postMessage(e.data, '*')
        }
        const _this = this
        // 弹出实名手机绑定
        if (e.data.type === 'forceVerify') {
          window.forceVerifyFlag = 1
          if (e.data.verify_type === 'phone') {
            if (!this.status.bindPhone) {
              this.goBindPhone()
            }
          }
          if (e.data.verify_type === 'realname') {
            if (!this.status.true_name) {
              this.heartbeatFunc('realName')
            }
          }
          if (((e.data.verify_type === 'phone') && this.status.bindPhone) || ((e.data.verify_type === 'realname') && this.status.true_name)) {
            window.forceVerifyFlag = 0
            window.frames[0].window.postMessage({
              type: 'forceVerify',
              res: {
                phone: _this.status.bindPhone ? 1 : 0,
                realname: _this.status.true_name ? 1 : 0
              }
            }, '*')
          }
        }
        // 获取用户信息
        if (e.data.type === 'getUserBaseInfo') {
          window.frames[0].window.postMessage({
            type: 'userBaseInfo',
            data: _this.status,
            succ: 1
          }, '*')
        }
      }, false)
    },
    // 加载游戏
    loadGame () {
      const isHttps = window.location.protocol === 'https:' ? 1 : 0
      const needMainCheck = this.$route.query.pf === 'h5_swap' ? 1 : 0
      const gameUrl = `//webapi.693975.com/web/index.php`
      const appid = this.init.identity || ''
      const gToken = this.$route.query.g_token
      const uid = this.status.uid
      const uname = this.status.username
      const token = this.token // 换成token
      const agentId = this.$route.query.agent_id || 100000
      const siteId = this.$route.query.site_id || 0
      const imei = this.idfa
      const os = this.$route.query.os || ''
      const model = this.$route.query.model || ''
      return `${gameUrl}?r=game/in&appid=${appid}&sub_appid=${appid}&uid=${uid}&uname=${uname}&session_id=${token}&agent_id=${agentId}&site_id=${siteId}&imei=${imei}&os=${os}&model=${model}&is_https=${isHttps}&need_main_check=${needMainCheck}&g_token=${gToken}`
    },
    switchLoginType (type) { //  切换loginType
      this.loginType = type
      this.visibility = false
      this.loginPhoneForm = this.$options.data().loginPhoneForm
      this.resetForm = this.$options.data().resetForm
      this.loginBoxClick = false
      if (type === 'register') {
        this.quickRegister()
      }
    },
    // 登陆
    async login (loginType) {
      if (this.adminLoading) {
        return
      }
      let obj = {}
      let status = false
      if (loginType === 'ACCOUNT') {
        status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.loginPhoneForm.username, msg: '账号不能为空' }, { val: this.loginPhoneForm.password, msg: '密码不能为空' }, { val: this.loginPhoneForm.code, options: { id: this.init.identity } }])
        obj = { username: this.loginPhoneForm.username, password: this.loginPhoneForm.password }
        if (status) {
          this.adminLoading = true
          let res = await this.$store.dispatch('login', obj)
          this.adminLoading = false
          if (res.ret !== 1) {
            this.$toast.error(res.msg ? res.msg : '请求错误')
          } else {
            setToken(res.data.session_id)
            this.openSimple = false
            this.$store.commit('SET_TOKEN', res.data.session_id)
            this.$toast.success('登录成功')
            this.getStatus()
            // 正常登陆情况记录账号密码
            this.loginUser(this.loginPhoneForm) //  记录账号密码
          }
        }
      } else {
        status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.phoneForm.phone, options: 'phone' }, { val: this.phoneForm.code, msg: '验证码不能为空' }, { val: this.phoneForm.wechat_code, options: { id: this.init.identity } }])
        obj = { login_type: loginType, phone: this.phoneForm.phone, code: this.phoneForm.code }
        if (status) {
          let res = await newPromise(phoneLogin, { phone: this.phoneForm.phone, code: this.phoneForm.code })
          if (res.ret !== 1) {
            this.$toast.error(res.msg ? res.msg : '请求错误')
          } else {
            setToken(res.data.session_id)
            this.openSimple = false
            this.$store.commit('SET_TOKEN', res.data.session_id)
            this.$toast.success('登录成功')
            this.getStatus()
          }
        }
      }
    },
    // 一键登录
    async oneLogin (data) {
      if (this.adminLoading) {
        return
      }
      this.adminLoading = true
      let res = await newPromise(oneLogin, data)
      this.adminLoading = false
      if (res.ret === 1) {
        setToken(res.data.session_id)
        this.openSimple = false
        this.$store.commit('SET_TOKEN', res.data.session_id)
        this.$toast.success('登录成功')
        if (res.data.username) {
          this.loginUser({ username: res.data.username, password: res.data.p })
        }
        this.getStatus()
      } else {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    //  注册
    async getRegister () {
      let status = false
      status = validate([{ val: this.check, msg: '请先阅读用户协议及隐私协议' }, { val: this.loginPhoneForm.username, msg: '账号不能为空' }, { val: this.loginPhoneForm.password, msg: '密码不能为空' }])
      if (status) {
        this.registerLoading = true
        const res = await this.$store.dispatch('register', this.loginPhoneForm)
        this.registerLoading = false
        if (res.ret === 1) {
          setToken(res.data.session_id)
          this.openSimple = false
          this.$store.commit('SET_TOKEN', res.data.session_id)
          this.$toast.success('注册成功')
          this.getStatus()
          this.loginUser(this.loginPhoneForm) //  记录账号密码
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    //  获取个人信息
    async getInit () {
      const res = await this.$store.dispatch('getInit')
      if (res.error_code) {
        this.$toast.error({ message: res.msg ? res.msg : '请求错误', time: 0 })
      } else {
        if (!getToken() || getToken() === 'undefined') {
          if (isWeixin()) { //  微信登陆
            this.wxLogin()
          } else { // 账号登陆
            // 有atk则表示从官网跳转过来执行atk登陆
            if (this.$route.query.atk && this.$route.query.token) {
              setToken(this.$route.query.token)
              this.getStatus()
            } else {
              this.dialogLoginShow()
              if (this.isOneLogin === '1' && isIOS()) {
                if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.XinHFiOSOneClick === 'object') {
                  window.webkit.messageHandlers.XinHFiOSOneClick.postMessage({ callNameKey: 'weOneClick' })
                }
              }
            }
          }
        } else {
          this.getStatus()
        }
      }
    },
    // 启动弹窗登陆流程
    dialogLoginShow () {
      this.openSimple = true
      this.addUserList()
      // 新登录逻辑
      this.initShow()
      // // 优先注册功能
      // if (this.init.fast_reg && this.init.ui_type === 3) {
      //   this.loginType = 'register'
      //   this.quickRegister()
      // }
    },
    //  获取游戏状态
    async getStatus () {
      const res = await this.$store.dispatch('getStatus')
      if (res.ret !== 1) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
        removeToken()
        if (this.status.use_heart) {
          const gameId = this.init.identity || ''
          const uid = this.status.uid || ''
          Cookies.remove(`htoken_${gameId}_${uid}`)
        }
        location.reload()
      } else {
        if (res.data.use_heart === 1) {
          this.hasHeartbeat = true
        }
        this.gameUrl = this.loadGame()
        this.fullIframe()
        moveDiv(this.$refs.am)
      }
    },
    async getCode (type) { //  获取验证码
      if ((type === 'reset' && this.resetDisabled) || (type !== 'reset' && this.codeDisabled)) {
        return
      }
      var res
      let status = false
      let phone = type === 'reset' ? this.resetForm.phone : this.phoneForm.phone
      status = validate([{ val: phone, options: 'phone' }])
      if (status) {
        if (type === 'reset') {
          this.resetDisabled = true
          this.resetCodeTime = 60
          let obj = {
            username: this.resetForm.username.trim(),
            phone: this.resetForm.phone.trim()
          }
          if (this.init.identity === 846) {
            obj.head = 'qtwl'
          }
          res = await newPromise(sendReSms, obj)
        } else {
          this.codeDisabled = true
          this.codeTime = 60
          let obj = {
            phone: this.phoneForm.phone.trim()
          }
          if (this.init.identity === 846) {
            obj.head = 'qtwl'
          }
          res = await newPromise(sendSms, obj)
        }
        if (res.ret === 1) {
          this.$toast.success('发送成功')
        } else {
          if (type === 'reset') {
            this.resetDisabled = false
          } else {
            this.codeDisabled = false
          }
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async resetSubmit () { //  重置密码
      let status = false
      status = validate([{ val: this.resetForm.username, msg: '用户名不能为空' }, { val: this.resetForm.phone, options: 'phone' }, { val: this.resetForm.code, msg: '验证码不能为空' }, { val: this.resetForm.password, msg: '密码不能为空' }, { val: [this.resetForm.password, this.resetForm.password_confirmation], options: 'same' }])
      if (status) {
        this.resetLoading = true
        const res = await newPromise(resetPassword, { username: this.resetForm.username, phone: this.resetForm.phone, code: this.resetForm.code, new_password: this.resetForm.password })
        this.resetLoading = false
        if (res.ret === 1) {
          this.$toast.success('重置成功')
          this.switchLoginType('user')
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async quickRegister () { //  一键注册
      if (this.qsLoading) {
        return
      }
      this.qsLoading = true
      const res = await newPromise(getRegisterAccount, { game_id: this.init.identity })
      this.qsLoading = false
      if (res.ret === 1) {
        this.visibility = true
        this.loginPhoneForm.username = res.data.username
        this.loginPhoneForm.password = res.data.password
      } else {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    userContentCheck () { //  选择用户协议内容
      this.openFullscreen = true
      getAgreementUrl({ game_id: this.init.identity }).then(res => {
        if (res.data.data.url) {
          this.userContent = res.data.data.url
        } else {
          this.userContent = '//image.693975.com/html/user_agreement.html'
        }
      }).catch(() => {
        this.$toast.error('请求错误')
      })
    },
    // 支付方法
    pay (type) {
      this.tanwanPay(type)
    },
    // 贪玩或695716支付
    tanwanPay (type) {
      if (type === 'wx') { this.payName = '微信' } else if (type === 'ali') { this.payName = '支付宝' }
      const payType = isMobile(type) ? type + 'Wap' : type + 'Qr'
      const imei = this.idfa
      const os = this.$route.query.os || ''
      const model = this.$route.query.model || ''
      const userName = this.status.username
      const uid = this.status.uid
      const gameId = this.init.identity
      const agentId = this.$route.query.agent_id || 100000
      const siteId = this.$route.query.site_id || 100000
      const pageFrom = this.$route.query.pf || '' //  pf
      this.payLoading = true
      if (type === 'wx') {
        if (isWeixin()) {
          wxJsPayNew(Object.assign({}, this.payData, { uid, user_name: userName, game_id: gameId, wx_openid: this.status.openid, agent_id: agentId, site_id: siteId })).then(res => {
            this.payLoading = false
            if (res.data.ret === 1) {
              const payInfo = res.data.data.info
              wx.wxJsPay(payInfo, this)
            }
          }).catch(() => {
            this.$toast.error('支付失败')
            this.payLoading = false
          })
          return
        }
      }
      console.log(this.payData, 123, os)
      pay(Object.assign({}, this.payData, { imei, os, model, uid, pay_type: payType, user_name: userName, game_id: gameId, return_url: window.location.href, agent_id: agentId, site_id: siteId }), type).then(res => {
        this.payLoading = false
        if (res.data.ret === 1) {
          if (res.data.data.info.is_sm_pop === 1) {
            this.$refs.heartbeat.showDialog(res.data.data.info)
            this.closePay()
            return
          }
          if (type === 'apple') {
            h5IosWapSdk.payApple({
              'order_id': res.data.data.info.oi,
              'username': userName,
              'server_id': this.payData.server_id,
              'ext': res.data.data.info.ext,
              'money': this.payData.money,
              'product_id': res.data.data.info.pgPrdti
            })
            return
          }
          // 交换包
          if (h5IosWapSdk.chkFrom(pageFrom)) {
            h5IosWapSdk.pay(res.data.data.info.url)
            this.closePay()
            return
          }
          if (isMobile()) {
            this.toPayUrl(res.data.data.info.url)
            setTimeout(() => {
              // 解决支付后回来没有关闭浮窗问题
              this.closePay()
            }, 5000)
          } else {
            this.code_img_url = res.data.data.info.code_img_url
            // this.pay_url = res.data.data.info.url
          }
        }
      }).catch(() => {
        this.payLoading = false
      })
    },
    // 支付调用方式
    toPayUrl (payUrl) {
      if (this.init.pull_pay_type === 'NORMAL') {
        window.location.href = payUrl
      } else if (this.init.pull_pay_type === 'NEW_TAB') {
        // IOS系统自带safari浏览器无法使用iframe调用scheme url，强制弹出新窗口
        if ((!browser.mobile && !browser.android) || (browser.ios && browser.mobile && !browser.weixin && !browser.QQ && !browser.xiaomi && !browser.baidu && !browser.UC && browser.safari)) {
          window.open(payUrl)
          return
        }
        var newWindow = window.open('about:blank')
        newWindow.location = payUrl
      } else if (this.init.pull_pay_type === 'IFRAME') {
        this.payUrl = payUrl
      } else if (this.init.pull_pay_type === 'POST_MESSAGE') {
        payUrl = decodeURIComponent(payUrl)
        payUrl = payUrl + '&session_id=' + getToken()
        window.webkit.messageHandlers.placeOrder.postMessage({ order: payUrl })
      } else if (this.init.pull_pay_type === 'TW_WEB') {
        var payData = {
          strInfo: payUrl
        }
        if (typeof window.initGameCall === 'function') {
          return window.initGameCall(payData)
        } else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers.initGameCall === 'object') {
          return window.webkit.messageHandlers.initGameCall.postMessage(payData)
        }
        this.$toast.error('支付失败')
      }
    },
    // 关闭支付
    closePay () {
      this.payDialog = false
      this.code_img_url = ''
      this.pay_url = ''
      this.order_id = ''
      this.orderCount = 0
      this.payUrl = ''
    },
    // 登记账号
    loginUser (obj) {
      if (localStorage.getItem('userList')) {
        const arr = JSON.parse(localStorage.getItem('userList'))
        if (!arr.some(v => { return v.username === obj.username })) {
          arr.length > 9 && arr.pop()
          arr.unshift(obj)
          localStorage.setItem('userList', JSON.stringify(arr))
        } else {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].username === obj.username) {
              arr.splice(i, 1)
              break
            }
          }
          arr.unshift(obj)
          localStorage.setItem('userList', JSON.stringify(arr))
        }
      } else {
        const arr = [obj]
        localStorage.setItem('userList', JSON.stringify(arr))
      }
    },
    // 选择账号
    selectUser (val, item) {
      for (const item of this.userList) {
        if (item.username === val) {
          this.loginPhoneForm.username = item.username
          this.loginPhoneForm.password = item.password
          this.loginBoxClick = false
        }
      }
    },
    // 获取user的列表
    addUserList () {
      if (localStorage.getItem('userList')) {
        this.userList = JSON.parse(localStorage.getItem('userList'))
        this.userInputList = this.userList.map(v => v.username)
      }
    },
    // 删除用户
    cleanUser (item, index) {
      this.userList.splice(index, 1)
      this.userInputList = this.userList.map(v => v.username)
      localStorage.setItem('userList', JSON.stringify(this.userList))
      if (this.loginPhoneForm.username === item) {
        this.loginPhoneForm = this.$options.data().loginPhoneForm
      }
    },
    // 开启游戏
    setGameUrl () {
      if (!this.gameUrl) {
        this.gameUrl = this.loadGame()
      }
    },
    async heartbeatFunc (val) {
      if (val === 'realName') {
        this.goRealNameRoute = true
        this.open = true
        // 跳转到实名认证
        setTimeout(() => {
          this.goRealNameRoute = false
        }, 100)
      }
      if (val === 'closeGame') {
        this.gameUrl = ''
      }
    },
    // 关闭心跳浮窗
    closeHeartbeatWindow () {
      if (this.status.use_heart) {
        this.$refs.heartbeat.closeIsHeartBeat()
        this.open = false
      }
    },
    // 检测ios是否开启无痕浏览
    checkIosTraceless () {
      var storage = window.sessionStorage
      try {
        storage.setItem('testIos', 'test')
        storage.removeItem('testIos')
        return true
      } catch (error) {
        alert('为了您的游戏体验，请不要在无痕模式下访问，否则账号自动登录等功能将无法正常使用。')
      }
    },
    isIOS () {
      return isIOS()
    }
  }
}
</script>

<style lang="less" scoped>
.mu-input {
  font-size: 14px;
  margin-bottom: 2px;
}
.mu-drawer {
  max-width: 400px; //  兼容pc端
}
.tar {
  text-align: right;
  overflow: hidden;
  font-size: 12px;
  line-height: 24px;
}
.reset {
  float: left;
  color: #333;
}
.back {
  color: #333;
  float: left;
  position: relative;
  z-index: 2;
}
.tips {
  font-size: 12px;
  line-height: 30px;
  color: #888;
  text-align: center;
}
.fast-login {
  margin-top: 20px;
  text-align: center;
  .title {
    border-top: 1px solid #e8e8e8;
    margin-top: 20px;
    line-height: 20px;
    text-align: center;
    span {
      position: relative;
      top: -11px;
      padding: 0 10px;
      background-color: #FFF;
      color: #999;
      font-size: 14px;
    }
  }
}
.mu-text-field {
  font-size: 14px;
}
.flex {
  display: flex;
  justify-content: center;
}
.flex-item {
  padding: 8px 0;
  margin: 0 10px;
  font-size: 16px;
  position: relative;
  display: flex;
  cursor: pointer;
  .icon-box {
    width: 25px;
    height: 25px;
    border-radius: 80%;
    background: #C2C2C2;
    img {
      display: block;
      width: 100%;
    }
  }
  .flex-title {
    line-height: 25px;
    margin-left: 10px;
    color: #999;
  }
}
.dl-title {
  font-size: 20px;
  color: #333;
  width: 100%;
  font-weight: 600;
  text-align: center;
  position: relative;
  .back-icon {
    font-size: .56rem;
    color: #CCCBCA;
    position: absolute;
    left: 4px;
    top: 3px;
  }
}
.check-box {
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  padding-bottom: .12rem;
  .mu-checkbox {
    vertical-align: text-bottom;
  }
  .check-p {
    color: #666;
    vertical-align: super;
    margin-left: .1rem;
  }
}
.h5-game-iframe {
  position: relative;
  display: block;
  z-index: 1;
  overflow:hidden;
  margin: 0 auto;
}
.h5-loading-cover {
  display: none;
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  background: #1e1e1e center;
  overflow: hidden;
  img {
    display: block;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .cover-img {
    width: 50%;
    top: 50%;
    left: 50%;
    transform:translate(-50%, -50%);
    height: auto;
  }
}
.am-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  top: 65%;
  left: 84%;
  white-space: nowrap;
  z-index: 9999990;
  animation: Twinkle 1s infinite alternate linear;
  img {
    display: block;
    width: 100%;
  }
  .qiwanwansdk_fuli {
    font-size: 12px;
    font-style: normal;
    border-radius: 8px;
    padding-left: 5px;
    padding-right: 5px;
    color: white;
    background-color: #FF7171;
    position: relative;
    bottom: 60px;
    right: -22px;
  }
}
.user-content {
  height: calc(100vh - 56px);
  width: 100%;
  overflow: hidden;
}
.dl-content {
  font-size: .2rem;
  color: #333;
  line-height: .36rem;
  letter-spacing: .06rem;
  .dl-c-title {
    padding-bottom: .2rem;
    font-size: .26rem;
    font-weight: 800;
  }
}
.dl-footer {
  display: flex;
  justify-content: space-between;
}
.dia-content-box {
  position: relative;
}
// 隐藏的iframe
.window_iframe {
  display: none;
}
.dialog-box {
  position: relative;
  .title-box {
    position: absolute;
    top: -22px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    .dl-title {
      font-size: .26rem;
      color: #57534E;
      text-align: center;
      width: 100%;
      padding: .3rem 0;
    }
    .close {
      position: absolute;
      right: -10px;
      top: 12px;
      font-size: .5rem;
      color: #CCCBCA;
    }
  }
  .dl-cont {
    padding-top: .6rem;
    text-align: center;
    padding-bottom: .3rem;
    .dl-c-title {
      font-size: .22rem;
      color: #6884F1;
      line-height: .3rem;
      padding-bottom: .22rem;
      span {
        color: #57534E;
        margin-left: .1rem;
      }
    }
    .money {
      font-size: .5rem;
      color: #FF9307;
      padding-bottom: .22rem;
    }
    .money-name {
      font-size: .22rem;
      color: #57534E;
    }
  }
  .dl-bot {
    .dl-b-title {
      color: #B5B5B5;
      font-size: .2rem;
      text-align: center;
      position: relative;
      margin-bottom: .16rem;
      .line {
        height: 1px;
        background: #E0E0E0;
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        z-index: 1;
      }
      span {
        position: relative;
        z-index: 2;
        background: #fff;
        padding: 0 .2rem;
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      .btn {
        margin: 0 .4rem;
      }
    }
  }
  .pc {
    text-align: center;
    display: block;
    overflow: hidden;
    .pc-img-box {
      width: 2.3rem;
      height: 2.3rem;
      margin: .8rem auto .2rem auto;
      img {
        display: block;
        width: 100%;
      }
    }
    .pc-title {
      font-size: .22rem;
      line-height: .36rem;
      color: #57534E;
      span {
        color: #FFA800;
        font-size: .3rem;
        margin: 0 .04rem;
      }
    }
    .pc-a {
      text-decoration:underline;
      font-size: .22rem;
      color: #6884F1;
      line-height: .36rem;
    }
  }
}
.home { //  强行更改组件不合理样式
  /deep/ .mu-tab {
    min-width: auto;
  }
}
// 横屏css
.horizontal {
  /deep/ .sub-header {
    .logo {
      display: none;
    }
  }
  /deep/ .nav {
    display: none;
  }
  /deep/ .flex-content {
    .nav_h {
      display: block;
    }
  }
}
.mb20 {
  margin-bottom: .2rem;
}
// 新版登陆界面样式
.new-login {
  /deep/ .mu-dialog {
    border-radius: .28rem;
  }
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  .l-title {
    font-size: 0.4rem;
    text-align: center;
    padding: 0.34rem 0;
    position: relative;
    .back {
      position: absolute;
      top: .45rem;
      left: .24rem;
      width: .38rem;
      height: .38rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .l-input {
    width: 91.5%;
    height: 0.72rem;
    border-radius: 0.08rem;
    background:rgba(248,246,249,1);
    margin: 0 auto 0.24rem auto;
    position: relative;
    .i-title {
      width: 24%;
      float: left;
      font-size: 0.28rem;
      color: #272727;
      line-height: 0.72rem;
      padding-left: 0.28rem;
      box-sizing: border-box;
    }
    .input-box {
      width: 65%;
      float: left;
      font-size: 0.28rem;
      color: #272727;
      background:rgba(248,246,249,1);
      line-height: 0.72rem;
      padding: 0;
    }
    .input-code {
      width: 40%;
    }
    .get-code {
      width: 36%;
      float: right;
      font-size: .28rem;
      color: #9C262C;
      text-align: center;
      line-height: .72rem;
    }
    .picture-box {
      width: 36%;
      float: right;
      height: .72rem;
      position: relative;
    }
    .select-icon {
      float: right;
      width: 11%;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        display: block;
        width: 35%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transition: all .3s ease;
      }
      .icon-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
        line-height: .72rem;
      }
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    input {
      border: 0;
      &:focus {
        outline: none;
      }
    }
    .select-list {
      display: none;
      width: 100%;
      max-height: 2.25rem;
      overflow: scroll;
      position: absolute;
      top: .72rem;
      left: 0;
      z-index: 2;
      .item {
        height: 0.72rem;
        width: 100%;
        background:rgba(248,246,249,1);
        border-top: 1px solid #fff;
        .p {
          width: 88%;
          display: block;
          float: left;
          padding-left: .29rem;
          line-height: .72rem;
          font-size: .28rem;
          color: #272727;
        }
        .clean {
          width: 12%;
          height: 100%;
          float: right;
          position: relative;
          z-index: 2;
          img {
            position: absolute;
            display: block;
            width: 40%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
    }
  }
  .selcet-input {
    .select-list {
      display: block;
    }
    .select-icon {
      img {
        transform: rotateZ(180deg);
        transition: all .3s ease;
      }
    }
  }
  .l-tips {
    text-align: center;
    line-height: 0.44rem;
    overflow: hidden;
    .l-img {
      width: 0.28rem;
      height: 0.28rem;
      display: inline-block;
      padding: 0.08rem;
      box-sizing: content-box;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .tips-left {
      margin-left: .24rem;
      float: left;
    }
    .lose-pwd {
      float: right;
      margin-right: .24rem;
      color: #56181B;
      font-size: .28rem;
    }
    .p {
      height: 0.44rem;
      vertical-align: super;
      font-size: 0.28rem;
      color: #454545;
      a {
        text-decoration:underline;
        color: #9C262C;
        padding-left: 0.08rem;
      }
    }
  }
  .l-button {
    margin: 0.2rem 0.26rem 0.3rem 0.26rem;
    text-align: center;
    height: 0.8rem;
    border-radius: 0.08rem;
    color: #fff;
    line-height: 0.8rem;
    font-size: 0.35rem;
    position: relative;
  }
  .l-bot {
    padding: 0 0.47rem 0.4rem 0.47rem;
    font-size: 0.28rem;
    color: #454545;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}

@media screen and (max-width:450px) {
  @f20: .2rem;
  @f26: .26rem;
  @f18: .18rem;
  .mu-input, .flex-item {
    font-size: @f20;
  }
  .dl-title {
    font-size: .36rem;
  }
  .code, .tar, .check-box, .tips {
    font-size: @f18;
  }
}
* { touch-action: pan-y; }  //  解决拖动时的报错提示

@keyframes Twinkle {
  0%{
    opacity: .5;
  }
  100% {
    opacity: .9;
  }
}
.wx-img-box {
  width: 100%;
  position: relative;
  padding: .2rem 0 .2rem 0;
  .wx-qrcode {
    width: 2.58rem;
    display: block;
    margin: 0 auto .1rem auto;
  }
  .wx-tips {
    font-size: .24rem;
    color: #333;
    text-align: center;
    padding-bottom: .1rem;
  }
}

.mudia {
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  /deep/ .mu-dialog {
    border-radius: .14rem;
    overflow: hidden;
  }
  /deep/ .mu-tab {
    font-size: 12px;
  }
}
</style>
